import NotFoundPage from 'modules/errors/pages/NotFoundPage';
import {useRouter} from 'next/router';
import {
    useGetWineShopEventsQuery,
    useGetWineShopProductsQuery,
    useGetWineShopXQuery,
} from 'modules/wineshops-list/services';
import {PageHead} from 'core/modules/PageHead';
import {WineShop} from 'modules/wineshops-list/pages/WineShop';
import {IBreadcrumb} from 'modules/seo/types';

interface IProps {
    breadcrumbs?: IBreadcrumb[];
}

export const WineShopWrapper = ({breadcrumbs = []}: IProps) => {
    const {query} = useRouter();

    const code = query?.code;

    const {data: wineshopResponse} = useGetWineShopXQuery({
        code: code as string,
    });

    const seoData = wineshopResponse?.seo;
    const title = seoData?.metaTitle ?? '';
    const robots = seoData?.robots ?? '';
    const description = seoData?.metaDescription ?? '';
    const pageTitle = seoData?.pageTitle ?? '';

    const {data: products} = useGetWineShopProductsQuery({
        code,
        pageSize: 4,
    });

    const {data: eventsRes} = useGetWineShopEventsQuery(
        {
            code: wineshopResponse?.data?.filterCode as string,
            pageSize: 4,
        },
        {skip: !wineshopResponse?.data?.filterCode},
    );

    const {data: eventsData} = eventsRes ?? {};

    if (!wineshopResponse?.data) {
        return <NotFoundPage />;
    }

    const wineshop = wineshopResponse?.data;

    return (
        <>
            <PageHead description={description} robots={robots} title={title} />
            <WineShop
                breadcrumbs={breadcrumbs}
                events={eventsData?.items ?? []}
                pageTitle={pageTitle}
                products={products}
                shop={wineshop}
            />
        </>
    );
};
